import React from 'react';
import {observer} from 'mobx-react-lite';
import {DeviceRow, DisplayStatus, VpnDisconnectReason} from '@src/dtos/device.dto';
import VpnOnIcon from '@svg/green-checkmark-circle.svg?react';
import InactiveIcon from '@svg/inactive-icon.svg?react';
import MessageIcon from '@svg/message.svg?react';

const VPN_OFF_REASON_LABELS: Record<VpnDisconnectReason, string> = {
    [VpnDisconnectReason.USER_DISABLED]: 'Disabled by user',
    [VpnDisconnectReason.CONNECTION_LOST]: 'Connectivity lost',
    [VpnDisconnectReason.VPN_FAILURE]: 'VPN failure',
    [VpnDisconnectReason.CERT_REVOKED]: 'Certificate revoked',
};

interface DevicesStatusCellProps {
    row: DeviceRow;
}

export const DevicesStatusCell: React.FC<DevicesStatusCellProps> = observer(({row}) => {
    if (row.displayStatus === DisplayStatus.PENDING || row.displayStatus === DisplayStatus.SENT) {
        return <div className="devices-status-cell">
            <MessageIcon className="status-icon"/>
            <div className="device-status-text">
                <span className="device-status-label">Invite sent</span>
            </div>
        </div>;
    }

    if (row.displayStatus === DisplayStatus.ACTIVE_VPN_ON) {
        return <div className="devices-status-cell">
            <VpnOnIcon className="status-icon"/>
            <div className="device-status-text">
                <span className="device-status-label">Protected</span>
            </div>
        </div>;
    }

    if (row.displayStatus === DisplayStatus.ACTIVE_VPN_OFF) {
        const subText = row.vpnDisconnectReason ? VPN_OFF_REASON_LABELS[row.vpnDisconnectReason] : undefined;
        return <div className="devices-status-cell">
            <InactiveIcon className="status-icon"/>
            <div className="device-status-text">
                <span className="device-status-label">Unprotected</span>
                {subText && <span className="device-status-subtext">{subText}</span>}
            </div>
        </div>;
    }

    return <div className="devices-status-cell">
        <InactiveIcon className="status-icon"/>
        <div className="device-status-text">
            <span className="device-status-label">Unprotected</span>
        </div>
    </div>;
});
